import { getCartSync } from '@/features/cart/model/store';
import { apiClient } from '@/shared/api';
import { FormActionState } from '@/shared/config';
import { promoCodeSchema, getApiErrorMessage } from '@/shared/lib';

export async function postCartPromo(
  prevState: FormActionState,
  formData: FormData,
) {
  const code = formData.get('code');

  try {
    await promoCodeSchema.validate({ code }, { abortEarly: false });

    await getCartSync().runBoundary('cart', () =>
      apiClient(`cart/promo-code`, {
        method: 'POST',
        body: JSON.stringify({ code }),
      }),
    );

    return {
      ...prevState,
      success: true,
    };
  } catch (error) {
    return {
      ...prevState,
      success: false,
      message: getApiErrorMessage(error),
    };
  }
}
